<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Update</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Document</v-stepper-step>

      <v-divider></v-divider>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <Update v-on:emitForm1="goNextStep" @stepDoc="setStepDoc"></Update>
      </v-stepper-content>

      <v-stepper-content step="2">
        <Document v-on:emitForm2="goNextStep" :stepId="step_id"></Document>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>


<script>
const commonService = require('../../../services/common.service');

import Update from './step_forms/update';
import Document from './step_forms/document';
export default {
  components: {
    Update,
    Document,
  },
  data() {
    return {
      e1: 0,
      step_id: '',
      // formSchema: {
      //   //pro_code: "",
      // }
    };
  },

    created () { },
   
    methods: {
    submitOperationActivities()
    {
      commonService.insertFormData(formSchema, "proc_execution").then(res => {           
            if(res.status==1) {
              this.e1 = 2
            }
          });
    },

    goNextStep(num)
    {
      this.e1 = num
    },
    setStepDoc(id){
      this.step_id = id
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/procurement/execution/executionForm.vue